const discountSections = document?.querySelectorAll('.discount-section');

discountSections?.forEach((item) => {
  const couponInput = item?.querySelector('.coupon-input');
  const input = couponInput?.querySelector('input');
  const text = couponInput?.querySelector('.coupon-text');
  const discountCode = item?.dataset?.coupon;
  const textAfterApply = item?.dataset?.textafterapply;
  const addToCartBtn = document?.querySelector('.product-form__submit');

  input?.addEventListener('change', function (e) {
    const value = e?.target?.checked;
    if (value) {

      couponInput?.classList?.add('active');
      // text.textContent = '30% coupon applied at checkout. Subscribe & Save orders only.';
      text.textContent = textAfterApply;

      if (discountCode) {
        document.cookie = `discount_code=${discountCode}; path=/`;

        fetch(`/discount/${discountCode}`)
          .then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                updates: {},
              }),
            });
          })
          .catch(function (error) {
            console.error('Error:', error);
          });
      }
    }
  });
  // addToCartBtn?.addEventListener('click',function(){

  //   if(!input?.checked){
  //     setTimeout(()=>{   
  //     fetch('/discount/ergregr').then(function () {
  //       return fetch('/cart/update.js', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           updates: {},
  //         }),
  //       });
  //     });
  //     document.cookie = 'discount_code=; Max-Age=0';

  //   },300)
  //   }
  // })
});
